import React from 'react';
import Link, { LINK_SIZES } from 'components/Link';
import ResponsiveImage from 'components/ResponsiveImage';
import PropTypes from 'prop-types';
import PoorText from 'components/PoorText';
import cn from 'classnames';

const MarketInsightUsefulPagesBlockItem = ({
  icon,
  title,
  introHtml,
  link,
}) => {
  return (
    <article className="marketInsight-useful-pages-block__item">
      <div
        className={cn('marketInsight-useful-pages-block__item-icon-container', {
          'marketInsight-useful-pages-block__item-icon-container_no-image':
            !icon,
        })}
      >
        {icon && (
          <ResponsiveImage
            {...icon}
            loading="lazy"
            className="marketInsight-useful-pages-block__item-icon responsive-image_size_market-insight-useful-pages-block"
            sources={[
              {
                width: 72,
              },
            ]}
          />
        )}
      </div>
      {title && (
        <h2 className="marketInsight-useful-pages-block__item-title">
          {title}
        </h2>
      )}
      {introHtml && (
        <PoorText
          className="marketInsight-useful-pages-block__item-intro poor-text_in-market-insight-useful-pages-block"
          text={introHtml}
        />
      )}
      {link && <Link {...link} size={LINK_SIZES.large} />}
    </article>
  );
};

MarketInsightUsefulPagesBlockItem.propTypes = {
  icon: PropTypes.exact(ResponsiveImage.propTypes),
  title: PropTypes.string,
  introHtml: PropTypes.string,
  link: PropTypes.exact(Link.propTypes),
};

export default MarketInsightUsefulPagesBlockItem;
